import React, { useEffect, useState } from "react";
import CountUp from "react-countup";
import { useDispatch, useSelector } from "react-redux";
import { getAllCompanies } from "../../../../../redux/companySlice/companySlice";
import { getAllContracts } from "../../../../../redux/contractSlice/contractSlice";

export default function Counters() {
  const dispatch = useDispatch();
  const { allCompanies } = useSelector((state) => state.company);
  const { allContracts } = useSelector((state) => state.contract);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        // جلب كل الشركات بـ page=0
        await dispatch(getAllCompanies(0)).unwrap();

        // جلب كل العقود بـ page=0
        await dispatch(getAllContracts(0)).unwrap();

        console.log("✅ Data loaded successfully");
      } catch (error) {
        console.error("❌ Error loading counters data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [dispatch]);

  // استخراج البيانات من Redux state
  const companiesData = Array.isArray(allCompanies?.data)
    ? allCompanies.data
    : [];

  const contractsData = Array.isArray(allContracts?.data)
    ? allContracts.data
    : [];

  console.log("Companies Data:", companiesData);
  console.log("Contracts Data:", contractsData);

  // حساب إجمالي الزيارات
  const totalVisits = contractsData.reduce(
    (total, contract) => total + (contract.maintenance_visits || 0),
    0,
  );

  // حساب الإحصائيات
  const totalCompanies =
    allCompanies?.pagination?.total || companiesData.length;
  const totalContracts =
    allContracts?.pagination?.total || contractsData.length;

  return (
    <>
      <div className="counters row justify-content-center align-items-center mb-5">
        {/* الشركات */}
        <div className="col-xxl-3 col-xl-4 col-lg-3 col-md-4 col-sm-6 mb-3">
          <div className="card p-3">
            <div className="d-flex justify-content-between align-items-center">
              <div className="px-3">
                <p className="mb-0">الشركات</p>
                <p className="fs-2 mb-0 highlight">
                  {loading ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : (
                    <CountUp end={totalCompanies} duration={2} />
                  )}
                </p>
              </div>
              <div className="counters-icon">
                <i className="fas fa-building"></i>
              </div>
            </div>
          </div>
        </div>

        {/* العقود */}
        <div className="col-xxl-3 col-xl-4 col-lg-3 col-md-4 col-sm-6 mb-3">
          <div className="card p-3">
            <div className="d-flex justify-content-between align-items-center">
              <div className="px-3">
                <p className="mb-0">العقود</p>
                <p className="fs-2 mb-0 highlight">
                  {loading ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : (
                    <CountUp end={totalContracts} duration={2} />
                  )}
                </p>
              </div>
              <div className="counters-icon">
                <i className="fas fa-file-signature"></i>
              </div>
            </div>
          </div>
        </div>

        {/* الزيارات */}
        <div className="col-xxl-3 col-xl-4 col-lg-3 col-md-4 col-sm-6 mb-3">
          <div className="card p-3">
            <div className="d-flex justify-content-between align-items-center">
              <div className="px-3">
                <p className="mb-0">إجمالي الزيارات</p>
                <p className="fs-2 mb-0 highlight">
                  {loading ? (
                    <span className="spinner-border spinner-border-sm"></span>
                  ) : (
                    <CountUp end={totalVisits} duration={2} />
                  )}
                </p>
              </div>
              <div className="counters-icon">
                <i className="fas fa-calendar-check"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
